/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'MultilineChart';

const classes = {
  container: `${PREFIX}-container`,
};

interface RootProps {
  height: string;
}

const Root = styled(Box)<RootProps>(({height}) => ({
  width: '100%',
  display: 'flex',
  height,

  [`& .${classes.container}`]: {
    width: '100%',
    position: 'relative',
  },
}));

interface ChartsContainerProps {
  height: string;
  top: string;
}

const ChartsContainer = styled(Box)<ChartsContainerProps>(({height, top}) => ({
  width: '100%',
  position: 'absolute',
  left: '0',
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  height,
  top,
}));

interface NormalChartsProps {
  height: string;
}

const NormalChartsContainer = styled(Box)<NormalChartsProps>(({height}) => ({
  height,
  display: 'flex',
  flexDirection: 'column',
}));

export {
  classes as MultilineChartClasses,
  Root as MultilineChartRoot,
  ChartsContainer,
  NormalChartsContainer,
};
